import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.array.join.js';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.object.to-string.js';
import { __rest } from 'tslib';
import React from 'react';

/**
 * A simple component that is set to display: flex.
 */
var Flex = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var _a$element = _a.element,
    element = _a$element === undefined ? 'div' : _a$element,
    _a$direction = _a.direction,
    direction = _a$direction === undefined ? 'row' : _a$direction,
    _a$display = _a.display,
    display = _a$display === undefined ? 'flex' : _a$display,
    wrap = _a.wrap,
    flex = _a.flex,
    justifyContent = _a.justifyContent,
    alignItems = _a.alignItems,
    alignContent = _a.alignContent,
    gap = _a.gap,
    children = _a.children,
    fullHeight = _a.fullHeight,
    fullWidth = _a.fullWidth,
    className = _a.className,
    style = _a.style,
    rest = __rest(_a, ["element", "direction", "display", "wrap", "flex", "justifyContent", "alignItems", "alignContent", "gap", "children", "fullHeight", "fullWidth", "className", "style"]);
  var classNames = ["cogs-" + display, "cogs-flex-" + direction, justifyContent && "cogs-justify-" + justifyContent, alignItems && "cogs-align-items-" + alignItems, alignContent && "cogs-align-content-" + alignContent, wrap && "cogs-flex-" + wrap, fullHeight && 'cogs-full-height', fullWidth && 'cogs-full-width', className].filter(Boolean);
  return /*#__PURE__*/React.createElement(element, Object.assign({
    className: classNames.join(' '),
    style: Object.assign({
      gap: gap,
      flex: flex
    }, style),
    ref: ref
  }, rest), children);
});

export { Flex };
